import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  EXPORT_SCHEDULE_DELETE_DELETE,
  EXPORT_SCHEDULE_GET_GET_OBJECT_EXPORT_SCHEDULES,
  EXPORT_SCHEDULE_POST_TOGGLE_STATUS,
} from '../endpoints/export-schedule.endpoints';

import { toQueryParams } from '../api-utils';

import { ExportSchedule } from 'src/app/core/models/core.models';

import { Observable } from 'rxjs';

// TODO: We will pass typized objects to the services containing all inputs
@Injectable({
  providedIn: 'root',
})
export class ExportScheduleApiService {
  private readonly http = inject(HttpClient);

  getExportSchedules(
    objectId: string,
    objectClassId: number,
  ): Observable<ExportSchedule[]> {
    const params = toQueryParams({
      object_id: objectId,
      object_class_id: objectClassId,
    });

    return this.http.get<ExportSchedule[]>(
      EXPORT_SCHEDULE_GET_GET_OBJECT_EXPORT_SCHEDULES,
      { params },
    );
  }

  /**
   * The endpoint reads nothing from the request - hence the empty body - and flips
   * the status from the stored one.
   */
  toggleExportScheduleStatus(scheduleId: string): Observable<any> {
    return this.http.post(EXPORT_SCHEDULE_POST_TOGGLE_STATUS(scheduleId), {});
  }

  deleteExportSchedule(exportScheduleId: string): Observable<boolean> {
    return this.http.delete<boolean>(
      EXPORT_SCHEDULE_DELETE_DELETE(exportScheduleId),
    );
  }
}
